import {kSystemIcons} from "../../../constants/icons";

export default function GamesScoreIcon() {
    // Used in GamesLeaveButton to display cancel
    // icon for leaving the game before the end

    // BUILD
    return (
        <div className={"w-[20px] min-w-[20px] max-w-[20px] flex justify-center"}>
            <i className={"material-icons text-[22px] text-trophyGreen"}>
                {kSystemIcons.trophy}
            </i>
        </div>
    );
}